import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "pi_token";

export const api = axios.create({ baseURL: API });

export const inviteTokenKey = (slug) => `pi_invite_${slug}`;
export const getInviteToken = (slug) => localStorage.getItem(inviteTokenKey(slug));

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const slug = (config.url || "").match(/^\/public\/events\/([^/]+)/)?.[1];
  const invite = slug && getInviteToken(slug);
  if (invite) config.headers["X-Invite-Token"] = invite;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.startsWith("/auth/") && !url.startsWith("/public/") && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export const imageUrl = (path, token) => (path ? `${API}/files/${path}${token ? `?t=${encodeURIComponent(token)}` : ""}` : null);
export const shareUrl = (slug) => `${window.location.origin}/e/${slug}`;

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  return detail.msg || String(detail);
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    el.remove();
  }
}
